var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      ref: "costReviewTable",
      attrs: {
        data: _vm.tableData,
        height: "100%",
        border: true,
        "header-cell-style": { color: "#333333", background: "#EFF6FF" },
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          prop: "field_key",
          align: "center",
          "min-width": "120",
          label: "属性名称",
          "show-overflow-tooltip": "",
          fixed: "left",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "field_map_txt",
          align: "center",
          label: "属性值",
          fixed: "left",
          "min-width": "120",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "is_must_txt", align: "center", label: "是否必选" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "is_searchable_txt",
          align: "center",
          label: "是否在分类页显示",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "sort", align: "center", label: "排序" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "tdc_owner_status",
          align: "center",
          label: "操作",
          width: "120",
          fixed: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                scope.row.system_type != 2
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onHandleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }